import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import {
  WalletCreditResponse,
  WalletCreditsHistoryTableData,
  WalletCreditsHistoryResponse,
  WalletCreditsHistoryTableRowActions
} from '../../../client-balance/add-funds-to-your-wallet/interfaces';

export const mapApiDataIntoTableFormat = (
  data: WalletCreditsHistoryResponse,
  actions: WalletCreditsHistoryTableRowActions
): WalletCreditsHistoryTableData[] =>
  data.credits.map((current: WalletCreditResponse) => {
    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(current.operationId);
        }
      }
    ];
    return {
      id: current.operationId,
      creditType: current.creditType,
      amount: current.creditAmount.value,
      status: current.creditStatus,
      date: current.attemptDate,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
